import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FooterComponent} from './footer/footer.component';
import {HeaderComponent} from './header/header.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {SidebarAltComponent} from './sidebar-alt/sidebar-alt.component';
import {LoadingIndicatorComponent} from './header/loading-indicator/loading-indicator.component';
import {RouterModule} from "@angular/router";
import {AccountService} from "../services/accountservice/account.service";
import {SharedModule} from "../shared/shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarAltComponent,
    LoadingIndicatorComponent
  ],
  providers: [
    AccountService
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarAltComponent,
    LoadingIndicatorComponent
  ]
})
export class BaseModule {
}
